import moment from "moment";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getMyCertificates } from "../../../store/actions/centerActions/centerExtras";

/*
  Affiliation certificates, in the center's own login.

  These used to be sent out by hand. Now one is issued the moment the
  registration fee is paid - full or partial, either counts - and another on
  every renewal. Nothing is replaced, so the certificate that covered an
  earlier year is still here when someone asks for it. The one in force is
  shown first and marked; the rest sit underneath as history.
*/
const dmy = (value) => (value ? moment(value).format("DD/MM/YYYY") : "--");

const MyAffiliation = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getMyCertificates()).then((data) => {
      setList(Array.isArray(data) ? data : []);
      setLoading(false);
    });
  }, [dispatch]);

  const current = list.find((c) => Number(c.is_current) === 1);
  const past = list.filter((c) => Number(c.is_current) !== 1);

  const expired = (c) => c.valid_to && moment(c.valid_to).isBefore(moment(), "day");

  const card = (c, isCurrent) => (
    <div class={`card p-3 mb-3 ${isCurrent ? "border-success" : ""}`} key={c.id}>
      <div class="row align-items-center">
        <div class="col-md-7">
          <h5 class="mb-1">
            {c.type === "renewal"
              ? `Renewal of Affiliation ${c.cycle_year || ""}`
              : "Grant of Affiliation"}
            {isCurrent && (
              <span class="badge badge-success ml-2">Current</span>
            )}
            {!isCurrent && expired(c) && (
              <span class="badge badge-secondary ml-2">Expired</span>
            )}
          </h5>
          <div class="text-muted">
            Certificate No. <b>{c.certificate_no}</b>
          </div>
          <div class="text-muted">
            Issued {dmy(c.issued_on)} &nbsp;|&nbsp; Valid {dmy(c.valid_from)} to{" "}
            {dmy(c.valid_to)}
          </div>
          {c.payment_type === "partial" && (
            <div class="text-muted small mt-1">
              Issued against a part payment. The balance is still shown on your
              Fee page.
            </div>
          )}
        </div>
        <div class="col-md-5 text-md-right mt-2 mt-md-0">
          <a
            class="btn btn-comman"
            href={c.link}
            target="_blank"
            rel="noreferrer"
          >
            Download PDF
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <div class="Title-box">
      <div class="row">
        <div class="col-md-6">
          <div class="BigTitle">Affiliation Certificate</div>
        </div>
      </div>

      <div class="mid-content-box mt-3">
        {loading ? (
          <div class="text-center mt-4">
            <Spinner animation="border" role="status" size="lg">
              <span class="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : list.length === 0 ? (
          <p>
            No affiliation certificate has been issued yet. It appears here on
            its own as soon as your registration fee is recorded.
          </p>
        ) : (
          <>
            {current && card(current, true)}

            {past.length > 0 && (
              <>
                <h6 class="mt-4 mb-2 text-muted">Earlier certificates</h6>
                {past.map((c) => card(c, false))}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MyAffiliation;
